




































import { Component, Prop } from "vue-property-decorator";

import AppVue from "@/AppVue.vue";
import { MentorGroupMemberModel } from "@/core/webapi";

@Component
export default class MentorGroupsTableCpt extends AppVue {
  @Prop() group: MentorGroupMemberModel;
}
